import { connect } from 'react-redux';

import { providerSurgeIncentiveSearchForm } from '../actions';
import ProviderSurgeIncentiveSearchForm from './provider-surge-incentive-search-form';

const mapStateToProps = state => ({
  formValues: state.providerSurgeIncentive.searchForm.formValues
});

const mapDispatchToProps = {
  changeField: providerSurgeIncentiveSearchForm.changeField,
  submit: providerSurgeIncentiveSearchForm.submit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveSearchForm);
